<template>
  <section class="panel">
    <div class="toolbar">
      <el-input v-model="query.keyword" placeholder="名称/型号" clearable style="width:180px" />
      <el-select v-model="query.seriesCategoryId" placeholder="系列分类" clearable style="width:150px">
        <el-option v-for="item in categories.SERIES" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="query.modelCategoryId" placeholder="型号分类" clearable style="width:150px">
        <el-option v-for="item in categories.MODEL" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="query.performanceCategoryId" placeholder="性能分类" clearable style="width:150px">
        <el-option v-for="item in categories.PERFORMANCE" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="query.status" placeholder="状态" clearable style="width:120px">
        <el-option label="上架" value="ON" />
        <el-option label="下架" value="OFF" />
      </el-select>
      <el-button class="btn-search" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="open()">新增产品</el-button>
      <el-upload action="" :show-file-list="false" accept=".xlsx" :http-request="importProducts">
        <el-button class="btn-upload" icon="el-icon-upload2">批量导入</el-button>
      </el-upload>
      <el-button class="btn-download" icon="el-icon-download" @click="exportProducts">导出</el-button>
    </div>
    <el-table :data="page.records" border size="small">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="name" label="名称" min-width="150" />
      <el-table-column prop="seriesCategoryName" label="系列分类" width="120" />
      <el-table-column prop="modelCategoryName" label="型号分类" width="120" />
      <el-table-column prop="performanceCategoryName" label="性能分类" width="120" />
      <el-table-column prop="productSpec" label="规格" min-width="180" show-overflow-tooltip />
      <el-table-column label="产品扫码核验总次数" width="150" align="right">
        <template slot-scope="{ row }">{{ row.totalScanCount || 0 }}</template>
      </el-table-column>
      <el-table-column prop="mainImageUrl" label="主图" width="90">
        <template slot-scope="{ row }">
          <el-image v-if="row.mainImageUrl" :src="absolute(row.mainImageUrl)" style="width:48px;height:36px" fit="cover" />
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 'ON' ? 'success' : 'info'" size="small">
            {{ statusText(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="{ row }">
          <el-button size="mini" class="btn-edit" icon="el-icon-edit" @click="open(row)">编辑</el-button>
          <el-button size="mini" :type="row.status === 'ON' ? 'warning' : 'success'" @click="setStatus(row)">
            {{ row.status === 'ON' ? '下架' : '上架' }}
          </el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :current-page="page.page"
      :page-size="page.size"
      :page-sizes="[10, 20, 50, 100]"
      :total="page.total"
      @size-change="size => { query.size = size; search() }"
      @current-change="p => { query.page = p; load() }"
    />

    <el-dialog :title="form.id ? '编辑产品' : '新增产品'" :visible.sync="dialog" width="920px">
      <el-form label-position="top">
        <div class="form-grid">
          <el-form-item label="产品名称"><el-input v-model="form.name" /></el-form-item>
          <el-form-item label="系列分类">
            <el-select v-model="form.seriesCategoryId" clearable style="width:100%">
              <el-option v-for="item in categories.SERIES" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="型号分类">
            <el-select v-model="form.modelCategoryId" clearable style="width:100%">
              <el-option v-for="item in categories.MODEL" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="性能分类">
            <el-select v-model="form.performanceCategoryId" clearable style="width:100%">
              <el-option v-for="item in categories.PERFORMANCE" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="form.status" style="width:100%">
              <el-option label="上架" value="ON" />
              <el-option label="下架" value="OFF" />
            </el-select>
          </el-form-item>
          <el-form-item label="排序"><el-input-number v-model="form.sort" :min="0" /></el-form-item>
        </div>
        <el-form-item label="产品简述">
          <el-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="请输入200字以内的产品简述"
          />
        </el-form-item>
        <el-form-item label="规格配置">
          <div class="spec-editor">
            <div v-for="(item, index) in form.params" :key="index" class="spec-row">
              <el-input v-model="item.paramName" placeholder="规格类型，如颜色/尺寸/材质" clearable />
              <el-input v-model="item.paramValue" placeholder="规格值，如黑色/XL/铝合金" clearable />
              <el-button
                icon="el-icon-delete"
                circle
                size="mini"
                :disabled="form.params.length === 1"
                @click="removeSpecRow(index)"
              />
            </div>
            <el-button size="mini" icon="el-icon-plus" @click="addSpecRow">添加规格</el-button>
          </div>
        </el-form-item>
        <el-form-item label="主图">
          <image-upload
            v-model="form.mainImageUrl"
            :file-id.sync="form.mainImageId"
            biz-type="product"
            @dimensions="setMainImageDimensions"
          />
          <div v-if="form.mainImageWidth && form.mainImageHeight" class="image-dimensions">
            已自动识别原图尺寸：{{ form.mainImageWidth }} x {{ form.mainImageHeight }}
          </div>
        </el-form-item>
        <el-form-item label="详情图文内容">
          <rich-text-editor v-model="form.detailContent" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import http, { absoluteUrl, downloadFile, MAX_UPLOAD_FILE_SIZE, UPLOAD_TIMEOUT } from '../api'
import ImageUpload from '../components/ImageUpload.vue'
import RichTextEditor from '../components/RichTextEditor.vue'

const blankPage = { total: 0, page: 1, size: 10, records: [] }
const categoryTypes = ['SERIES', 'MODEL', 'PERFORMANCE']
const productStatusText = { ON: '上架', OFF: '下架' }
const blankProduct = () => ({
  name: '',
  description: '',
  status: 'ON',
  sort: 100,
  params: [{ paramName: '', paramValue: '', sort: 10 }]
})

export default {
  components: { ImageUpload, RichTextEditor },
  data() {
    return {
      query: { page: 1, size: 10 },
      page: { ...blankPage },
      categories: { SERIES: [], MODEL: [], PERFORMANCE: [] },
      dialog: false,
      form: {}
    }
  },
  mounted() {
    this.loadCategories()
    this.load()
  },
  methods: {
    absolute: absoluteUrl,
    statusText(status) {
      return productStatusText[status] || status || '-'
    },
    async loadCategories() {
      for (const type of categoryTypes) {
        this.categories[type] = await http.get('/admin/categories', { params: { categoryType: type } })
      }
    },
    async load() {
      this.page = await http.get('/admin/products', { params: this.query })
    },
    search() {
      this.query.page = 1
      this.load()
    },
    async open(row) {
      if (!row) {
        this.form = blankProduct()
        this.dialog = true
        return
      }
      this.form = { ...blankProduct(), ...row, params: this.normalizeParams([], row.productSpec) }
      this.dialog = true
      const detail = await http.get(`/admin/products/${row.id}`)
      this.form = {
        ...blankProduct(),
        ...detail.product,
        params: this.normalizeParams(detail.params, detail.product && detail.product.productSpec)
      }
    },
    async save() {
      if (this.form.description && this.form.description.length > 200) {
        this.$message.error('产品简述不能超过200字')
        return
      }
      const params = this.cleanSpecParams()
      if (!params) return

      const product = { ...this.form }
      delete product.params
      product.productSpec = this.specSummary(params)

      const images = product.mainImageUrl
        ? [{
            fileId: product.mainImageId,
            imageUrl: product.mainImageUrl,
            imageType: 'MAIN',
            imageWidth: product.mainImageWidth,
            imageHeight: product.mainImageHeight,
            sort: 1
          }]
        : []
      const payload = { product, images, params }
      if (this.form.id) {
        await http.put(`/admin/products/${this.form.id}`, payload)
      } else {
        await http.post('/admin/products', payload)
      }
      this.dialog = false
      this.$message.success('已保存')
      this.load()
    },
    setMainImageDimensions(dimensions) {
      this.form.mainImageWidth = dimensions && dimensions.width ? dimensions.width : null
      this.form.mainImageHeight = dimensions && dimensions.height ? dimensions.height : null
    },
    async setStatus(row) {
      await http.put(`/admin/products/${row.id}/status`, { status: row.status === 'ON' ? 'OFF' : 'ON' })
      this.load()
    },
    async remove(row) {
      await this.$confirm('确认删除该产品？')
      await http.delete(`/admin/products/${row.id}`)
      this.load()
    },
    async importProducts({ file }) {
      if (file.size > MAX_UPLOAD_FILE_SIZE) {
        this.$message.error('上传文件不能超过500MB')
        return
      }
      const form = new FormData()
      form.append('file', file)
      const data = await http.post('/admin/products/import', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: UPLOAD_TIMEOUT
      })
      this.$message.success(`导入完成：新增 ${data.created}，更新 ${data.updated}，跳过 ${data.skipped}`)
      this.load()
    },
    async exportProducts() {
      const params = new URLSearchParams()
      Object.entries(this.query).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.append(key, value)
      })
      try {
        await downloadFile(`/admin/products/export?${params.toString()}`, 'products.xlsx')
      } catch (error) {
        this.$message.error(error.message || '导出失败')
      }
    },
    addSpecRow() {
      this.form.params.push({ paramName: '', paramValue: '', sort: (this.form.params.length + 1) * 10 })
    },
    removeSpecRow(index) {
      this.form.params.splice(index, 1)
      if (!this.form.params.length) this.addSpecRow()
    },
    normalizeParams(params, legacySpec) {
      const list = (params || []).map((item, index) => ({
        paramName: item.paramName || item.key || '',
        paramValue: item.paramValue || item.value || '',
        sort: item.sort || (index + 1) * 10
      }))
      if (!list.length && legacySpec) {
        list.push({ paramName: '规格', paramValue: legacySpec, sort: 10 })
      }
      return list.length ? list : [{ paramName: '', paramValue: '', sort: 10 }]
    },
    cleanSpecParams() {
      const source = this.form.params || []
      const touched = source.filter(item => (item.paramName && item.paramName.trim()) || (item.paramValue && item.paramValue.trim()))
      const invalid = touched.some(item => !(item.paramName && item.paramName.trim()) || !(item.paramValue && item.paramValue.trim()))
      if (invalid) {
        this.$message.error('规格类型和规格值需要成对填写')
        return null
      }
      return touched.map((item, index) => ({
        paramName: item.paramName.trim(),
        paramValue: item.paramValue.trim(),
        sort: (index + 1) * 10
      }))
    },
    specSummary(params) {
      return params.map(item => `${item.paramName}: ${item.paramValue}`).join('；').slice(0, 255)
    },
  }
}
</script>

<style scoped>
.spec-editor {
  display: grid;
  gap: 10px;
}

.spec-row {
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(220px, 1.4fr) 36px;
  gap: 10px;
  align-items: center;
}

.image-dimensions {
  margin-top: 8px;
  color: #7d8798;
  font-size: 12px;
}
</style>
